import { ZPARCoordinates, I24MXCoordinates, UBPECoordinates } from './SitesCoordinates';

const coordinates = {
  ZPAR: ZPARCoordinates,
  '24MX': I24MXCoordinates,
  UBPE: UBPECoordinates
};

const zoomMap = {
  ZPAR: { mobile: 11.1, regular: 11.5 },
  '24MX': { mobile: 11.1, regular: 11.0 },
  UBPE: { mobile: 11.1, regular: 12.5 }
};

const centerMap = {
  ZPAR: {
    lat: -34.5988258154,
    lng: -58.4427202617
  },
  '24MX': {
    lat: 19.3361990689,
    lng: -99.2468084475
  },
  UBPE: {
    lat: -12.1240025,
    lng: -77.0148573
  }
};

const markersCenter = {
  ZPAR: [
    // Palermo:
    { lat: -34.5737840529, lng: -58.4225970163 },
    // PuertoMadero:
    { lat: -34.6091828654, lng: -58.3563758657 },
    // Nordelta:
    { lat: -34.4139870896, lng: -58.6503567202 },
    // Belgrano:
    { lat: -34.555964857, lng: -58.4501759367 },
    // Caballito:
    { lat: -34.6168103976, lng: -58.4436079289 },
    // Recoleta:
    { lat: -34.5849316871, lng: -58.3945792848 },
    // Villa Urquiza:
    { lat: -34.5715435648, lng: -58.487868385 },
    // Núñez:
    { lat: -34.5431611853, lng: -58.4618036811 }
  ],
  '24MX': [
    // Miguel Hidalgo:
    { lat: 19.428108085, lng: -99.2045803283 },
    // Alvaro Obregón:
    { lat: 19.3361990689, lng: -99.2468084475 },
    // Cuajimalpa:
    { lat: 19.3246475193, lng: -99.3107474667 },
    // Magdalena Contreras:
    { lat: 19.2690075933, lng: -99.2684085772 }
  ],
  UBPE: [
    // Barranco
    { lat: -12.1440295172, lng: -77.0208625217 },
    // San Borja
    { lat: -12.0975463369, lng: -76.9952085586 },
    // La Molina
    { lat: -12.0880856621, lng: -76.925728618 },
    // Miraflores
    { lat: -12.1209111982, lng: -77.0289336384 },
    // San Isidro
    { lat: -12.0989772706, lng: -77.0366628587 },
    // Santiago de Surco
    { lat: -12.1269346421, lng: -76.9843459348 }
  ]
};

const polygonsZones = site => {
  return (
    coordinates[site] &&
    coordinates[site].map(zone => ({
      paths: zone.map(coord => ({ lng: coord[0], lat: coord[1] }))
    }))
  );
};

export { zoomMap, centerMap, markersCenter, polygonsZones };
